import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import { VerifyRecipientTokenRequest, VerifyRecipientTokenSuccessResponse } from './verifyRecipientToken.types'

export const verifyRecipientTokenApi = async (
  request: VerifyRecipientTokenRequest
): Promise<VerifyRecipientTokenSuccessResponse> => {
  const response = await configureRequest({
    url: `fulfillment-orders/recipient/verify/${request.token}`,
    method: 'GET',
    headers: {
      // No auth required - this is a public endpoint
    }
  })

  return response as VerifyRecipientTokenSuccessResponse
}
